import { Pipe, PipeTransform } from '@angular/core';
import { statusLabel } from '../enums/status-labels';

@Pipe({
	name: 'statusLabel',
})
export class StatusLabelPipe implements PipeTransform {
	transform(status: string): string {
		return statusLabel(status);
	}
}
